import { Component, ViewChild, OnInit, Output, EventEmitter } from "@angular/core";
import { User } from "src/classes/Automation/UserApp";
import { Tag } from "src/classes/Automation/Tag";
import { DynamicDialogService } from "src/app/services/Customer/dynamic-dialog/dynamic-dialog.service";

type TagType = Tag & { isUsed?: boolean };

@Component({
    selector: "app-childeditor",
    templateUrl: "./childeditor.component.html",
    styleUrls: ["./childeditor.component.css"],
    providers: []
})
export class ChildeditorComponent implements OnInit {
    receivedConfig: { message: string, textareaId: number, layouts: Tag[] };

    @ViewChild("textareaElement", { static: false }) textareaElement: any;
    textarea: string = "";
    textareaLength: number = 0;
    user: User = new User();
    allLayouts: Tag[];
    layouts: TagType[];

    @Output() textareaOutput = new EventEmitter<object>();

    isSaveable: boolean = true;

    textBeforeLink: string = "לאישור הגעה לחץ כאן";

    constructor(
        private dynamicDialogService: DynamicDialogService,
    ) { }

    ngOnInit(): void {
        this.receivedConfig = this.dynamicDialogService.getConfigData();
        this.user.useremail = sessionStorage.getItem("email");

        this.textarea = this.receivedConfig.message;
        this.textareaLength = this.textarea.length;

        this.allLayouts = this.receivedConfig.layouts;

        this.layouts = this.allLayouts.filter((layout: TagType) => layout.template_id == this.receivedConfig.textareaId + 1);
        this.layouts.forEach((layout: TagType) => {
            if ((this.textarea.split("[" + layout.hebrew_name + "]").length > 1 && !layout.mandatory) ||
                (this.textarea.split("{" + layout.hebrew_name + "}").length > 1 && layout.mandatory)) {
                layout.isUsed = true;
            }
            else {
                layout.isUsed = false;
            }
        });

        this.isSaveable = this.areAllMandatoryLayoutsUsed();
    }

    closeDialog(): void {
        this.dynamicDialogService.closeDialog();
    }

    areAllMandatoryLayoutsUsed(): boolean {
        let mandatoryLayouts = this.layouts.filter((layout: TagType) => layout.mandatory);

        for (let i = 0; i < mandatoryLayouts.length; i++) {
            if (this.textarea.split("{" + mandatoryLayouts[i].hebrew_name + "}").length < 2) {
                return false;
            }
        }

        return true;
    }

    saveText(): void {
        this.dynamicDialogService.closeDialog(this.textarea);
    }

    textareaClick(event: KeyboardEvent): void {
        let cursorPosition: number = this.getCursorPosition();
        let [rightPosition, leftPosition, bracketType]: number[] = this.isInBracket(cursorPosition);
        let keyCodes: number[] = [37, 38, 39, 40];

        if (event.keyCode == 221 || event.keyCode == 219 || (event.keyCode == 221 && event.shiftKey == true) || (event.keyCode == 219 && event.shiftKey == true)) {
            event.preventDefault();
        }

        if (rightPosition >= 0 && leftPosition >= 0) {
            if (!keyCodes.includes(event.keyCode)) {
                event.preventDefault();
            }
        }

        if (this.textareaElement.nativeElement.selectionStart == this.textareaElement.nativeElement.selectionEnd) {
            if (event.keyCode == 8) {
                if (rightPosition < 0 || leftPosition < 0) {
                    [rightPosition, leftPosition, bracketType] = this.isInBracket(cursorPosition - 1);
                }

                if (rightPosition >= 0 && leftPosition >= 0) {
                    this.deleteLayout(event, rightPosition, leftPosition, bracketType);
                }
            }

            if (event.keyCode == 46) {
                if (rightPosition < 0 || leftPosition < 0) {
                    [rightPosition, leftPosition, bracketType] = this.isInBracket(cursorPosition + 1);
                }

                if (rightPosition >= 0 && leftPosition >= 0) {
                    this.deleteLayout(event, rightPosition, leftPosition, bracketType);
                }
            }
        }
        else if ((event.keyCode == 8 || event.keyCode == 46) && rightPosition >= 0 && leftPosition >= 0) {
            this.deleteLayout(event, rightPosition, leftPosition, bracketType);
        }

        this.textareaLength = this.textarea.length;
    }

    textareaKeyUp(): void {
        for (let i = 0; i < this.layouts.length; i++) {
            if ((this.textarea.split("[" + this.layouts[i].hebrew_name + "]").length > 1 && !this.layouts[i].mandatory) || (this.textarea.split("{" + this.layouts[i].hebrew_name + "}").length > 1 && this.layouts[i].mandatory)) {
                this.layouts[i].isUsed = true;
            }
            else {
                this.layouts[i].isUsed = false;
            }
        }

        this.isSaveable = this.areAllMandatoryLayoutsUsed();
    }

    textareaPaste(event: ClipboardEvent): void {
        let pastedText: string = event.clipboardData.getData("text").split("[").join("").split("]").join("").split("{").join("").split("}").join("");

        let cursorPosition: number = this.getCursorPosition();
        let [rightPosition, leftPosition]: number[] = this.isInBracket(cursorPosition);

        event.preventDefault();
        if (rightPosition < 0 || leftPosition < 0) {
            this.textarea = this.textarea.slice(0, cursorPosition) + pastedText + this.textarea.slice(cursorPosition);

            setTimeout(() => {
                this.textareaElement.nativeElement.selectionEnd = cursorPosition + pastedText.length;
            }, 0);
        }

        this.textareaLength = this.textarea.length;
    }

    layoutClick(layout: TagType): void {
        let cursorPosition: number = this.getCursorPosition();
        let [rightPosition, leftPosition]: number[] = this.isInBracket(cursorPosition);

        if (layout.isUsed) {
            layout.isUsed = false;
            let deletedLayout: string[] = [];
            if (layout.mandatory) {
                deletedLayout = this.textarea.split("{" + layout.hebrew_name + "}");
            }
            else {
                deletedLayout = this.textarea.split("[" + layout.hebrew_name + "]");
            }

            if (deletedLayout[0].split("").pop() == " " && deletedLayout[1] != "") {
                deletedLayout[0] = deletedLayout[0].slice(0, -1);
            }
            this.textarea = deletedLayout.join("");

            this.textareaElement.nativeElement.focus();
            setTimeout(() => {
                this.textareaElement.nativeElement.selectionEnd = deletedLayout[0].length;
            }, 0);
        }
        else {
            if (rightPosition < 0 || leftPosition < 0) {
                layout.isUsed = true;

                if (layout.mandatory) {
                    if (layout.name != "Link") {
                        this.textarea = this.textarea.slice(0, cursorPosition) + "{" + layout.hebrew_name + "}" + this.textarea.slice(cursorPosition);
                    }
                    else {
                        this.textarea = this.textarea.slice(0, cursorPosition) + "\n" + this.textBeforeLink + "\n" + "{" + layout.hebrew_name + "}" + this.textarea.slice(cursorPosition);
                    }
                }
                else {
                    if (layout.name != "Link") {

                        this.textarea = this.textarea.slice(0, cursorPosition) + "[" + layout.hebrew_name + "]" + this.textarea.slice(cursorPosition);
                    }
                    else {
                        this.textarea = this.textarea.slice(0, cursorPosition) + "\n" + this.textBeforeLink + "\n" + "[" + layout.hebrew_name + "]" + this.textarea.slice(cursorPosition);
                    }
                }

                this.textareaElement.nativeElement.focus();
                setTimeout(() => {
                    this.textareaElement.nativeElement.selectionEnd = cursorPosition + layout.hebrew_name.length + 2;
                }, 0);
            }
            else {
                this.textareaElement.nativeElement.focus();
                setTimeout(() => {
                    this.textareaElement.nativeElement.selectionEnd = cursorPosition;
                }, 0);
            }
        }

        this.isSaveable = this.areAllMandatoryLayoutsUsed();

        this.textareaLength = this.textarea.length;
    }

    emojiClick(emoji: string): void {
        let cursorPosition: number = this.getCursorPosition();
        let [rightPosition, leftPosition]: number[] = this.isInBracket(cursorPosition);

        if (rightPosition < 0 || leftPosition < 0) {
            this.textarea = this.textarea.slice(0, cursorPosition) + emoji + this.textarea.slice(cursorPosition);

            this.textareaElement.nativeElement.focus();
            setTimeout(() => {
                this.textareaElement.nativeElement.selectionEnd = cursorPosition + 2;
            }, 0);
        }
        else {
            this.textareaElement.nativeElement.focus();
            setTimeout(() => {
                this.textareaElement.nativeElement.selectionEnd = cursorPosition;
            }, 0);
        }

        this.textareaLength = this.textarea.length;
    }

    getCursorPosition(): number {
        if (this.textareaElement.nativeElement.selectionEnd != this.textareaElement.nativeElement.selectionStart) {
            if (this.textareaElement.nativeElement.selectionDirection == "forward") {
                return this.textareaElement.nativeElement.selectionEnd;
            }
            else {
                return this.textareaElement.nativeElement.selectionStart;
            }
        }
        else {
            return this.textareaElement.nativeElement.selectionEnd;
        }
    }

    isInBracket(cursor: number): number[] {
        let leftPosition: number = -1;
        let rightPosition: number = -1;
        let bracketType: number = 1;

        for (let i = cursor - 1; i >= 0; i--) {
            if (this.textarea[i] == "[") {
                leftPosition = i + 1;
                break;
            }
            else if (this.textarea[i] == "]") {
                leftPosition = -1;
                break;
            }
        }

        for (let i = cursor; i < this.textarea.length; i++) {
            if (this.textarea[i] == "]") {
                rightPosition = i;
                break;
            }
            else if (this.textarea[i] == "[") {
                rightPosition = -1;
                break;
            }
        }

        if (rightPosition == -1 || leftPosition == -1) {
            for (let i = cursor - 1; i >= 0; i--) {
                if (this.textarea[i] == "{") {
                    leftPosition = i + 1;
                    break;
                }
                else if (this.textarea[i] == "}") {
                    leftPosition = -1;
                    break;
                }
            }

            for (let i = cursor; i < this.textarea.length; i++) {
                if (this.textarea[i] == "}") {
                    rightPosition = i;
                    break;
                }
                else if (this.textarea[i] == "{") {
                    rightPosition = -1;
                    break;
                }
            }

            if (rightPosition != -1 && leftPosition != -1) {
                bracketType = 2;
            }
        }

        return [rightPosition, leftPosition, bracketType];
    }

    deleteLayout(event: Event, rightPosition: number, leftPosition: number, bracketType: number): void {
        event.preventDefault();

        this.layouts.find((layout: TagType) => layout.hebrew_name == this.textarea.slice(leftPosition, rightPosition)).isUsed = false;

        let deletedLayout = [];
        if (bracketType == 1) {
            if (this.textarea.slice(leftPosition, rightPosition) == this.allLayouts.find(element => element.name == "Link").hebrew_name) {
                deletedLayout = this.textarea.split("[" + this.textarea.slice(leftPosition, rightPosition) + "]");

                if (deletedLayout[0].split(this.textBeforeLink)[1] && deletedLayout[0].split(this.textBeforeLink)[1].trim() == "") {
                    deletedLayout[0] = [deletedLayout[0].split(this.textBeforeLink)[0], deletedLayout[0].split(this.textBeforeLink)[1].trim()].join("");
                }
            }
            else {
                deletedLayout = this.textarea.split("[" + this.textarea.slice(leftPosition, rightPosition) + "]");
            }
        }
        else if (bracketType == 2) {
            deletedLayout = this.textarea.split("{" + this.textarea.slice(leftPosition, rightPosition) + "}");
        }

        if (deletedLayout[0].split("").pop() == " " && deletedLayout[1] != "") {
            deletedLayout[0] = deletedLayout[0].slice(0, -1);
        }
        this.textarea = deletedLayout.join("");

        setTimeout(() => {
            this.textareaElement.nativeElement.selectionEnd = deletedLayout[0].length;
        }, 0);
    }
}
